











import Vue from 'vue'
import CClassifiedCertificateViewer from '~/components/shared/configurable/classified/certificate/CClassifiedCertificateViewer.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
export default Vue.extend({
  components: { CClassifiedCertificateViewer, CCard },
  props: {
    certificates: {
      type: Object,
      required: true
    }
  }
})
